export const AddDigitalID = {
  "Title": "Add Digital ID",
  "Next": "Next",
  "Back": "Back",
  "Finish": "Finish",
  "Store": {
    "Title": "Where would you like to store your self-signed digital ID?",
    "File": "New PKCS#12 digital ID file",
    "FileDescription": "Creates a new password protected digital ID file that uses the standard PKCS#12 format. This common digital ID file format is supported by most security software applications, including major web browsers.PKCS#12 files have a .pfx or .p12 file extension.",
    "Windows": "Windows Certificate Store",
    "WindowsDescription": "Your digital ID will be stored in the Windows Certificate Store where it will also be available to other Windows applications. The digital ID will be protected by your Windows login."
  },
  "IdentityInfo": {
    "Title": "Enter your identity information to be used when generating the self-signed certificate.",
    "Label": {
      "Name": "Name (e.g.John Smith):",
      "OrgUnit": "Organizational Unit:",
      "OrgName": "Organization Name:",
      "EmailAddr": "Email Address:",
      "Country": "Country/Region:",
      "KeyAgrthm": "Key Algorithm:",
      "UseFor": "Use Digital ID for:"
    },
    "EmptyEmail": "Please enter a valid email address!",
    "EmptyName": "A name is required to create a self-signed digital ID.",
    "DigitalSignatures": "Digital Signatures",
    "DataEncryption": "Data Encryption",
    "SignaturesEncryption": "Digital Signatures and Data Encryption",
    "None": "None",
    "Bit": "bit",
    "CountryAndRegion": {
      "AD": "Andorra",
      "AE": "United Arab Emirates",
      "AF": "Afghanistan",
      "AG": "Antigua and Barbuda",
      "AI": "Anguilla",
      "AL": "Albania",
      "AM": "Armenia",
      "AN": "Netherlands Antilles",
      "AO": "Angola",
      "AQ": "Antarctica",
      "AR": "Argentina",
      "AS": "American Samoa",
      "AT": "Austria",
      "AU": "Australia",
      "AW": "Aruba",
      "AX": "Aland",
      "AZ": "Azerbaijan",
      "BA": "Bosnia and Herzegovina",
      "BB": "Barbados",
      "BD": "Bangladesh",
      "BE": "Belgium",
      "BF": "Burkina Faso",
      "BG": "Bulgaria",
      "BH": "Bahrain",
      "BI": "Burundi",
      "BJ": "Benin",
      "BM": "Bermuda",
      "BN": "Brunei Darussalam",
      "BO": "Bolivia",
      "BR": "Brazil",
      "BS": "Bahamas",
      "BT": "Bhutan",
      "BV": "Bouvet Island",
      "BW": "Botswana",
      "BY": "Belarus",
      "BZ": "Belize",
      "CA": "Canada",
      "CC": "Cocos Island",
      "CD": "Congo, the Democratic Republic of the",
      "CF": "Central African Republic",
      "CG": "Congo",
      "CH": "Switzerland",
      "CK": "Cook Islands",
      "CL": "Chile",
      "CM": "Cameroon",
      "CN": "China",
      "CO": "Colombia",
      "CR": "Costa Rica",
      "CS": "Serbia",
      "CU": "Cuba",
      "CX": "Christmas Island",
      "CY": "Cyprus",
      "CZ": "Czech Republic",
      "DE": "Germany",
      "DJ": "Djibouti",
      "DK": "Denmark",
      "DM": "Dominica",
      "DO": "Dominican Republic",
      "DZ": "Algeria",
      "EC": "Ecuador",
      "EE": "Estonia",
      "EG": "Egypt",
      "EH": "Western Sahara",
      "ER": "Eritrea",
      "ES": "Spain",
      "ET": "Ethiopia",
      "FI": "Finland",
      "FJ": "Fiji",
      "FK": "Falkland Islands (Malvinas)",
      "FM": "Federated States of Micronesia",
      "FO": "Faroe Islands",
      "FR": "France",
      "GA": "Gabon",
      "GB": "United Kingdom",
      "GD": "Grenada",
      "GE": "Georgia",
      "GF": "French Guiana",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GL": "Greenland",
      "GM": "Gambia",
      "GN": "Guinea",
      "GP": "Guadeloupe",
      "GQ": "Equatorial Guinea",
      "GR": "Greece",
      "GS": "South Georgia and the South Sandwich Islands",
      "GT": "Guatemala",
      "GU": "Guam",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HK": "Hong Kong",
      "HM": "Heard Island and McDonald Islands",
      "HN": "Honduras",
      "HR": "Croatia",
      "HT": "Haiti",
      "HU": "Hungary",
      "ID": "Indonesia",
      "IE": "Ireland",
      "IL": "Israel",
      "IN": "India",
      "IO": "British Indian Ocean Territory",
      "IQ": "Iraq",
      "IR": "Iran, Islamic Republic Of",
      "IS": "Iceland",
      "IT": "Italy",
      "JM": "Jamaica",
      "JO": "Jordan",
      "JP": "Japan",
      "KE": "Kenya",
      "KG": "Kyrgyzstan",
      "KH": "Cambodia",
      "KI": "Kiribati",
      "KM": "Comoros",
      "KN": "Saint Kitts and Nevis",
      "KP": "Korea, Democratic People's Republic of",
      "KR": "Korea, Republic of",
      "KW": "Kuwait",
      "KY": "Cayman Islands",
      "KZ": "Kazakhstan",
      "LA": "Laos People's Democratic Republic",
      "LB": "Lebanon",
      "LC": "Saint Lucia",
      "LI": "Liechtenstein",
      "LK": "Sri Lanka",
      "LR": "Liberia",
      "LS": "Lesotho",
      "LT": "Lithuania",
      "LU": "Luxembourg",
      "LV": "Latvia",
      "LY": "Libya Arab Jamahiria",
      "MA": "Morocco",
      "MC": "Monaco",
      "MD": "Moldova, Republic of",
      "MG": "Madagascar",
      "MH": "Marshall Islands",
      "MK": "Macedonia, The Former Yugoslavian Republic",
      "ML": "Mali",
      "MM": "Myanmar",
      "MN": "Mongolia",
      "MO": "Macao",
      "MP": "Northern Marianna Islands",
      "MQ": "Martinique",
      "MR": "Mauritania",
      "MS": "Montserrat",
      "MT": "Malta",
      "MU": "Mauritius",
      "MV": "Maldives",
      "MW": "Malawi",
      "MX": "Mexico",
      "MY": "Malaysia",
      "MZ": "Mozambique",
      "NA": "Namibia",
      "NC": "New Caledonia",
      "NE": "Niger",
      "NF": "Norfolk Islands",
      "NG": "Nigeria",
      "NI": "Nicaragua",
      "NL": "Netherlands",
      "NO": "Norway",
      "NP": "Nepal",
      "NR": "Nauru",
      "NU": "Niue",
      "NZ": "New Zealand",
      "OM": "Oman",
      "PA": "Panama",
      "PE": "Peru",
      "PF": "French Polynesia",
      "PG": "Papua New Guinea",
      "PH": "Philippines",
      "PK": "Pakistan",
      "PL": "Poland",
      "PM": "Saint Pierre and Miquelon",
      "PN": "Pitcairn",
      "PR": "Puerto Rico",
      "PS": "Palestinian Territory, Occupied",
      "PT": "Portugal",
      "PW": "Palau",
      "PY": "Paraguay",
      "QA": "Qatar",
      "RE": "Reunion",
      "RO": "Romania",
      "RU": "Russian Federation",
      "RW": "Rwanda",
      "SA": "Saudi Arabia",
      "SB": "Solomon Islands",
      "SC": "Seychelles",
      "SD": "Sudan",
      "SE": "Sweden",
      "SG": "Singapore",
      "SH": "Saint Helena",
      "SI": "Slovenia",
      "SJ": "Svalbard And Jan Mayen",
      "SK": "Slovakia",
      "SL": "Sierra Leone",
      "SM": "San Marino",
      "SN": "Senegal",
      "SO": "Somalia",
      "SR": "Suriname",
      "ST": "Sao Tome and Principe",
      "SV": "El Salvador",
      "SY": "Syrian Arab Republic",
      "SZ": "Swaziland",
      "TC": "Turks And Caicos Islands",
      "TD": "Chad",
      "TF": "French Southern Territories",
      "TG": "Togo",
      "TH": "Thailand",
      "TJ": "Tajikistan",
      "TK": "Tokelau",
      "TM": "Turkmenistan",
      "TN": "Tunisia",
      "TO": "Tonga",
      "TP": "East Timor",
      "TR": "Turkey",
      "TT": "Trinidad And Tobago",
      "TV": "Tuvalu",
      "TW": "Taiwan",
      "TZ": "Tanzania, United Republic Of",
      "UA": "Ukraine",
      "UG": "Uganda",
      "UK": "United Kingdom",
      "UM": "United States Minor Outlying Islands",
      "US": "United States",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VA": "Vatican",
      "VC": "Saint Vincent And The Grenadines",
      "VE": "Venezuela",
      "VG": "Virgin Islands, British",
      "VI": "Virgin Islands, U.S.",
      "VN": "Vietnam",
      "VU": "Vanuatu",
      "WF": "Wallis And Futuna",
      "WS": "Samoa",
      "YE": "Yemen",
      "YT": "Mayotte",
      "ZA": "South Africa",
      "ZM": "Zambia",
      "ZW": "Zimbabwe"
    }
  },
  "OtherInfo": {
    "Title": "Enter a password for your new digital ID file. You will need the password when you use the digital ID to sign or decrypt the documents. It downloads the digital ID file automatically after you setting up the password.",
    "Label": {
      "Filename": "File name",
      "Password": "Password",
      "ConfirmPassword": "Confirm Password"
    },
    "NotMatchPassword": "Passwords do not match.",
    "ErrorPassword": "Password must be at least six characters long.",
    "ErrorFilenameFormat": "Invalid file name."
  },
  "Browse": {
    "Title": "Browse for a digital ID file. Digital ID files are password protected and require your password in order to be opened.",
    "FileName": "File Name",
    "Password": "Password",
    "Browse": "Browse",
    "EmptyFile": "Non-empty file name required",
    "EmptyPassword": "Enter a Password to open the digital ID file.",
    "InvalidFileFormat": "Invalid file format."
  },
  "BrowseConfirm": {
    "Title": "The following digital IDs will be added to your list of digital IDs that you can use for signing or encryption:",
    "Expires": "Expires"
  },
  "CreateOrExist": {
    "Title": "I want to sign this document using:",
    "Exist": "My existing digital ID from a file",
    "New": "A new digital ID I want to create now"
  },
  "ErrorSameName": "A digital ID file with the same name already exists. Would you like to replace the existing file?"
}